/**
 * API response types
 */

/**
 * Standard API error response structure
 */
export interface ApiErrorResponse {
  detail: string;
  message?: string;
}

/**
 * Type guard to check if an unknown value is an ApiErrorResponse
 */
export function isApiErrorResponse(value: unknown): value is ApiErrorResponse {
  return (
    typeof value === 'object' &&
    value !== null &&
    'detail' in value &&
    typeof (value as any).detail === 'string'
  );
}
